import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavigationWrapper from '../../components/NavigationWrapper';
import FooterWrapper from '../../components/FooterWrapper';
import philteamfoto from '../../assets/about/Phil_Teamfoto.webp';

const BackofficeAutomations = () => {
  const [copied, setCopied] = useState(false);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-[#010003] flex flex-col">
      <NavigationWrapper />
      
      <article className="relative z-10 bg-[#010003] pt-48 pb-24">
        {/* Grid Lines Background */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="w-[1080px] mx-auto h-full relative">
            {/* Horizontal lines */}
            <div className="absolute left-0 right-0 top-[128px] h-px bg-[#16181d]"></div>
            {/* Content starts below this line */}
            <div className="absolute left-0 right-0 bottom-0 h-px bg-[#16181d]"></div>
            {/* Vertical grid lines */}
            <div className="absolute left-0 top-[128px] bottom-0 w-px bg-[#16181d]"></div>
            <div className="absolute left-1/3 top-[128px] bottom-0 w-px border-l border-dashed border-[#16181d]"></div>
            <div className="absolute left-2/3 top-[128px] bottom-0 w-px border-l border-dashed border-[#16181d]"></div>
            <div className="absolute right-0 top-[128px] bottom-0 w-px bg-[#16181d]"></div>
          </div>
        </div>

        <div className="w-[1080px] mx-auto relative z-10">
          {/* Back to Blog Link */}
          <div className="flex justify-center w-full">
            <Link 
              to="/blog" 
              className="inline-flex items-center gap-2 text-white/60 text-sm font-geist tracking-[-0.02em] hover:text-white transition-colors mb-12"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Blog
            </Link>
          </div>

          {/* Article Header */}
          <header className="max-w-[720px] mx-auto text-center mb-16">
            <h1 className="text-white text-[42px] font-geist font-normal tracking-[-0.02em] leading-tight mb-8">
              Die 6 Backoffice-Automatisierungen, die Großhandels-, Fertigungs- und Logistikunternehmen nicht ignorieren können: Effizienz steigern und Kosten senken
            </h1>
            
            {/* Author Info */}
            <div className="flex items-center justify-center gap-3 mb-24">
              <div className="w-6 h-6 rounded-full overflow-hidden">
                <img 
                  src={philteamfoto}
                  alt="Philipp Fuchs" 
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-white text-sm font-geist tracking-[-0.02em]">Philipp Fuchs</span>
              <span className="text-white/60 text-xs font-geist tracking-[-0.02em]">CEO</span>
            </div>

            {/* Meta Info */}
            <div className="w-full flex items-center justify-between text-white/60 text-sm font-geist tracking-[-0.02em] px-0">
              <div className="flex items-center gap-6">
                <div className="flex items-center gap-2">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5"/>
                    <path d="M8 4V8L10.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                  </svg>
                  15 min Lesezeit
                </div>
                <div className="relative overflow-hidden">
                  <button 
                    onClick={() => {
                      navigator.clipboard.writeText(window.location.href);
                      setCopied(true);
                      setTimeout(() => setCopied(false), 2000);
                    }}
                    onMouseLeave={() => setCopied(false)}
                    className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer relative"
                  >
                    <img src="/link.svg" alt="" className="w-3 h-3 flex-shrink-0" />
                    <div className="relative h-5 overflow-hidden w-32">
                      <span className={`block whitespace-nowrap text-left transition-transform duration-300 ${copied ? '-translate-y-full' : 'translate-y-0'}`}>
                        Copy URL
                      </span>
                      <span className={`absolute inset-0 whitespace-nowrap text-left transition-transform duration-300 ${copied ? 'translate-y-0' : 'translate-y-full'}`}>
                        Link kopiert!
                      </span>
                    </div>
                  </button>
                </div>
              </div>
              <span>Okt 10, 2025</span>
            </div>
          </header>

          {/* Article Content */}
          <div className="max-w-[720px] mx-auto">
            <div className="prose prose-invert">
              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Stellen Sie sich vor: Es ist Freitag, 15 Uhr. Ihr Großhandelsbetrieb hat gerade 47 Verkaufsaufträge per E-Mail, Fax und über das uralte Portal erhalten, das Ihr größter Kunde partout weiter nutzen möchte. Währenddessen versucht Ihre Fertigungsabteilung herauszufinden, ob die Produktion für nächste Woche überhaupt realisierbar ist, weil niemand die tatsächliche Kapazität kennt. In der Logistik prüft jemand manuell 200 Versanddokumente, während sich Supportanfragen über verspätete Lieferungen stapeln.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Willkommen in der Büro-Realität, die still und leise die Gewinnspannen im Großhandel, in der Fertigung und Logistik auffrisst. Unternehmen, die zwar physische Waren in der realen Welt bewegen, aber Informationen verarbeiten, als wären wir noch im Jahr 1995.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Hier ist, was niemand gerne zugibt: Während sich das Silicon Valley mit Metaverse und fliegenden Autos beschäftigt, ertrinken die Unternehmen, die tatsächlich die Wirtschaft am Laufen halten, in PDFs, Tabellen und E-Mails. Der durchschnittliche Großhändler gibt 23 % seines Umsatzes für Betriebskosten aus, ein Großteil davon reiner Verwaltungsaufwand. Fertigungsunternehmen verlieren 20 % ihrer Produktivität durch manuelle Planungsprozesse. Logistikdienstleister bearbeiten täglich Tausende von Dokumenten mit Fehlerquoten von 10-15 %.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Aber hier kommt die überraschende Wendung: Diese "langweiligen" Branchen sitzen auf der größten Automatisierungschance des Jahrzehnts. Im Gegensatz zu Technologieunternehmen, die bereits alles Digitale optimiert haben, haben traditionelle Unternehmen das Potenzial bei weitem noch nicht ausgeschöpft. Wir sprechen hier von Effizienzsteigerungen von 70-90 %, die direkt vor unserer Nase liegen.
              </p>




              <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mt-12 mb-6">Warum Großhandel, Fertigung und Logistik anders sind (und warum das Ihr versteckter Vorteil ist)</h2>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Seien wir ehrlich: Diese drei Branchen teilen sich einen einzigartigen Fluch. Sie bewegen physische Produkte in einer digitalen Welt. Jedes Produkt, jede Palette und jede Sendung existiert gleichzeitig in der realen Welt und in 47 verschiedenen Softwaresystemen, die kaum miteinander kommunizieren.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Der perfekte Sturm der Komplexität</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Großhändler</strong> jonglieren mit Tausenden von Artikeln, Hunderten von Lieferanten, schwankenden Preisen und Kunden, die tatsächlich noch per Fax bestellen. Ja, per Fax. Im Jahr 2025.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Hersteller</strong> balancieren Rohstoffe, Produktionskapazitäten, Qualitätsstandards und Liefertermine, während ihr ERP-System eine andere Sprache spricht als ihr MES, das wiederum nicht mit dem WMS kommuniziert.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Logistiker</strong> koordinieren Versender, Spediteure, Zollbehörden, Lager und Empfänger – und ertrinken dabei in Frachtbriefen, Lieferscheinen und Zolldokumenten, die selbst Kafka zum Weinen bringen würden.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Was diese Branchen so besonders macht? Sie können sich nicht einfach „schnell bewegen und Dinge brechen“. Wenn Sie 20 Tonnen Stahl verschicken, kosten Fehler nicht nur Geld – sie können ganze Lieferketten lahmlegen.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Der verborgene Vorteil</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Aber hier ist, was das Silicon Valley nicht versteht: Diese Komplexität ist Ihr Wettbewerbsvorteil. Während jeder ein weiteres SaaS-Startup gründen kann, schafft es nicht jeder, 10.000 Artikel über 50 Lager hinweg zu verwalten, 200 Lieferanten zu koordinieren und dabei eine Liefergenauigkeit von 99,7 % zu gewährleisten.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Unternehmen, die es schaffen, diese komplexen Backoffice-Prozesse zu automatisieren, werden nicht nur Geld sparen, sondern sie werden ihre Branchen dominieren. Denn wenn Sie schneller anbieten, präziser liefern und sofort reagieren können, während die Konkurrenz noch Daten in Excel einträgt, gewinnen Sie nicht nur durch den Preis. Sie gewinnen in jeder Hinsicht.
              </p>

              <div className="overflow-x-auto mb-8">
                <table className="min-w-full border border-[#2d2f36]">
                  <thead>
                    <tr className="bg-[#0e0f13]">
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-b border-[#2d2f36] font-geist">Bereich</th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-b border-[#2d2f36] font-geist">Herausforderung</th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-[#2d2f36] font-geist">Automatisierungspotenzial</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#2d2f36] bg-[#010003]">
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist font-medium">Großhandel</td>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Tausende Artikel, veraltete Bestellwege, volatile Preise</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Automatisierte Bestellabwicklung, intelligente Preisgestaltung</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist font-medium">Fertigung</td>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Inkompatible Systeme, komplexe Lieferketten</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Systemübergreifende Integration, Echtzeit-Planung</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist font-medium">Logistik</td>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Dokumentenflut, mangelnde Transparenz</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Automatisierte Dokumentenverarbeitung, Echtzeit-Tracking</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Die Zukunft gehört nicht den Unternehmen mit den tiefsten Taschen, sondern denen, die ihre komplexen Prozesse am besten beherrschen. Die Automatisierung Ihres Backoffice ist dabei kein Kostenfaktor, sie ist Ihr strategischer Vorsprung.
              </p>










              <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mt-12 mb-6">Anwendungsfall 1: Verkaufsaufträge ohne nervenaufreibende Dateneingabe erstellen</h2>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Der aktuelle Albtraum</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Verfolgen wir einen typischen Verkaufsauftrag durch Ihr Unternehmen:
              </p>

              <ol className="list-decimal pl-6 mb-6 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed space-y-2">
                <li>Kunde sendet eine Bestellung per E-Mail (oder schlimmer: ein Foto einer handschriftlichen Liste)</li>
                <li>Ein Vertriebsmitarbeiter gibt die Daten manuell ins CRM ein</li>
                <li>Jemand anderes trägt sie erneut ins ERP-System ein</li>
                <li>Ein weiterer Mitarbeiter prüft den Lagerbestand in drei verschiedenen Systemen</li>
                <li>Jemand validiert die Preise anhand der aktuellsten Liste (welche Version ist eigentlich die aktuelle?)</li>
                <li>Die Auftragsbestätigung wird getippt und versendet</li>
                <li>Man betet, dass nichts bei der Übertragung verloren gegangen ist</li>
              </ol>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Zeit pro Auftrag: 15-45 Minuten. Fehlerquote: 5-10 %. Kosten der Fehler: Ihre Nerven und die Kundenbeziehungen.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die KI-Automatisierungs-Realität</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Moderne <strong>KI-Dokumentenverarbeitung</strong> digitalisiert Bestellungen nicht nur – sie versteht sie. Hier ist, was tatsächlich passiert:
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Intelligente Extraktion:</strong> Die KI liest Bestellungen aus jedem Format – E-Mail, PDF, Excel, sogar von Fotos von Skizzen auf der Serviette. Sie versteht, dass „Menge“, „Anzahl“ und „Stück“ alle dasselbe bedeuten.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Intelligente Validierung:</strong> Automatische Prüfung gegen Ihren Produktkatalog, aktuellen Lagerbestand, kundenspezifische Preise und Kreditlimits. Sie weiß, dass mit „der üblichen Bestellung“ von Bobs Baumarkt 500 Einheiten der Artikelnummer 4847B gemeint sind.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Automatische Erfassung:</strong> Erstellt Aufträge direkt in Ihrem ERP, CRM und WMS gleichzeitig. Kein erneutes Eintippen. Keine Fehler. Keine Verzögerungen.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Branchenspezifische Magie</h3>

              <div className="space-y-4 mb-6">
                <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed">
                  <strong>Für den Großhandel:</strong> Bewältigung komplexer Preisstufen, Mengenrabatte und kundenspezifischer Kataloge. Ein Großhändler konnte die Auftragsbearbeitung von 25 Minuten auf 90 Sekunden reduzieren und dabei das Auftragsvolumen verdreifachen.
                </p>
                <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed">
                  <strong>Für die Fertigung:</strong> Direkte Verknüpfung von Aufträgen mit der Produktionsplanung. Wissen Sie sofort, ob Sie aus dem Lager liefern oder produzieren müssen. Automatische Auslösung der Materialbeschaffung. Diese nahtlose Integration ist genau das, was <strong>KI-Automatisierung für die Fertigung</strong> leistet.
                </p>
                <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed">
                  <strong>Für die Logistik:</strong> Erstellen Sie Versandaufträge, generieren Sie Etiketten, buchen Sie Spediteure und versenden Sie Versandinformationen – alles ausgehend vom ursprünglichen Auftrag.
                </p>
              </div>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die Rendite, die CFOs vor Freude weinen lässt</h3>

              <div className="overflow-x-auto mb-8">
                <table className="min-w-full border border-[#2d2f36]">
                  <thead>
                    <tr className="bg-[#0e0f13]">
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-b border-[#2d2f36] font-geist">Vorteil</th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-[#2d2f36] font-geist">Kennzahl</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#2d2f36] bg-[#010003]">
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Arbeitskosteneinsparungen</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">85 % weniger Zeit für die Auftragserfassung</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Fehlerreduzierung</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Von 5-10 % auf unter 0,5 % gesenkt</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Schnellere Auftragserfüllung</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Minuten statt Stunden</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Skalierbarkeit</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">10-faches Auftragsvolumen ohne zusätzliches Personal</td>
                    </tr>
                  </tbody>
                </table>
              </div>










              <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mt-12 mb-6">Anwendungsfall 2: Rechnungen mit Lichtgeschwindigkeit bearbeiten (nicht im Tempo von Buchhalter Bob)</h2>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die schmerzhafte Wahrheit über die Rechnungsbearbeitung</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Ihre Finanzbuchhaltung ist ein schwarzes Loch, in dem Rechnungen verschwinden. Sie kommen per E-Mail, Post, Portal und Brieftaube (okay, vielleicht nicht wirklich, aber es fühlt sich so an). Jede einzelne muss:
              </p>

              <ul className="list-disc pl-6 mb-6 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed space-y-2">
                <li>Manuell ins Buchhaltungssystem eingegeben werden</li>
                <li>Mit Bestellungen abgeglichen werden (wenn man sie denn findet)</li>
                <li>Zur Freigabe weitergeleitet werden (über E-Mail-Ketten, die selbst Dante beeindrucken würden)</li>
                <li>Erneut ins Zahlungssystem eingegeben werden</li>
                <li>Irgendwo abgelegt werden, wo man sie nie wiederfindet</li>
              </ul>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Durchschnittliche Zeit pro Rechnung: 15-20 Minuten. Verspätete Zahlungsstrafen: 2 % Ihrer jährlichen Ausgaben. Verpasste Skonti: Weitere 2 %. Das sind insgesamt 4 % Ihrer Gesamtbeschaffungskosten, die durch manuelle Bearbeitung verloren gehen.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die Automatisierungs-Revolution</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Die KI-gestützte Rechnungsverarbeitung verwandelt diesen Albtraum in einen reibungslosen Traum:
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Universelle Erfassung:</strong> Verarbeitung von Rechnungen jedes Lieferanten in jedem Format. Keine Vorlagen erforderlich. Die KI versteht Rechnungen wie ein Mensch, braucht aber keine Kaffeepausen.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Dreifach-Abgleich:</strong> Automatische Abgleiche mit Bestellungen und Wareneingängen. Diskrepanzen werden sofort erkannt, anstatt sie erst am Monatsende zu entdecken.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Intelligente Weiterleitung:</strong> Automatische Freigabe basierend auf Betrag, Abteilung, Lieferant oder anderen Geschäftsregeln. Schluss mit dem E-Mail-Pingpong.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Automatische Buchung:</strong> Direkte Verbuchung im ERP mit korrekten Sachkonten, Kostenstellen und Projektcodes.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Warum das für Ihre Branche besonders wichtig ist</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Großhandel:</strong> Bei äußerst geringen Margen (oft nur 3-5 %) können Skonti Ihre Nettomarge bei Einkäufen verdoppeln. Ein Großhändler sichert sich so jährlich 300.000 € an Skonti, die er zuvor verpasst hat. Berechnen Sie Ihr Einsparpotenzial mit unserem kostenlosen ROI-Rechner.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Fertigung:</strong> Abgleich mit komplexen Stücklisten und mehrstufigen Wareneingängen. Automatische Kostenverteilung auf Aufträge und Projekte. Verfolgung der Komponentenkosten für präzise Margenanalysen.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Logistik:</strong> Tausende von Frachtrechnungen, Kraftstoffzuschläge und Zusatzgebühren ohne Kopfschmerzen verarbeiten. Automatische Überprüfung der Gebühren gemäß Verträgen und Service-Levels.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die wichtigsten Kennzahlen</h3>

              <div className="overflow-x-auto mb-8">
                <table className="min-w-full border border-[#2d2f36]">
                  <thead>
                    <tr className="bg-[#0e0f13]">
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-b border-[#2d2f36] font-geist">Kennzahl</th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-[#2d2f36] font-geist">Wert</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#2d2f36] bg-[#010003]">
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Bearbeitungskosten</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Von 15-30 € auf 1-2 € pro Rechnung</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Bearbeitungszeit</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Von Tagen auf Stunden reduziert</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Zahlungsoptimierung</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">98 % der Skonti werden genutzt</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Prüfpfad</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">100 % digitale Nachverfolgung mit automatischem Dreifach-Abgleich</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Möchten Sie genau wissen, wie viel Sie sparen könnten? Unser detaillierter Leitfaden zur Automatisierung der Rechnungsverarbeitung mit KI zeigt Unternehmen, wie sie jährlich über 100.000 € einsparen können.
              </p>

              <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mt-12 mb-6">Anwendungsfall 3: Supportanfragen beantworten, bevor sie gestellt werden (ernsthaft!)</h2>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die Support-Ticket-Lawine</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Ihr Support-Team ertrinkt in immer den gleichen Fragen, nur leicht anders formuliert, tausendfach:
              </p>

              <ul className="list-disc pl-6 mb-6 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed space-y-2">
                <li>„Wie ist der Status meiner Bestellung PO-48573?“</li>
                <li>„Können Sie mir eine Kopie der Rechnung INV-2024-789 zusenden?“</li>
                <li>„Wie lang ist die Lieferzeit für Artikel-Nr. 4847?“</li>
                <li>„Ist meine Sendung bereits versandt worden?“</li>
                <li>„Wie lauten Ihre Zahlungsbedingungen?“</li>
              </ul>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Jede Anfrage benötigt 5-15 Minuten Bearbeitungszeit. Multipliziert mit Hunderten täglich. Das ist der gesamte Arbeitstag Ihres Teams, nur für Fragen, die automatisiert werden könnten.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die KI-Support-Revolution</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Moderne KI-Agenten beantworten nicht nur Fragen, sondern verstehen Absichten und ergreifen Maßnahmen:
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Natürliche Sprachverarbeitung:</strong> Kunden können Fragen stellen, wie sie möchten. Die KI versteht, dass „Wo bleibt meine Bestellung?“ bedeutet: „Wie ist der Status meiner letzten Bestellung?“
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Tiefe Integration:</strong> Verbindung zu ERP, WMS, TMS und CRM für Echtzeit-Informationen. Kein „Ich schaue nach und melde mich bei Ihnen“ mehr nötig.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Proaktive Kommunikation:</strong> Warten Sie nicht auf Kundenanfragen. Informieren Sie automatisch über Verzögerungen, Sendungen oder Probleme, bevor sie zu Support-Tickets werden.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Intelligente Eskalation:</strong> Erkennt, wann ein Mensch für komplexe Probleme oder verärgerte Kunden eingeschaltet werden muss. Erfahren Sie mehr über Kundensupport-Automatisierung, die über einfache Chatbots hinausgeht.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Branchenspezifische Superkräfte</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Großhandel:</strong> Sofortige Antworten zu Produktverfügbarkeit, Preisen und Ersatzvorschlägen. Ein Großhändler reduzierte Support-Tickets um 70 % und verbesserte die Antwortzeit von Stunden auf Sekunden. Sie bauten eine KI-gestützte Wissensdatenbank auf, die Kunden rund um die Uhr Selbstbedienung ermöglicht.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Fertigung:</strong> Echtzeit-Status zu Produktion, Qualitätszertifikaten und technischen Spezifikationen. Automatische Generierung von Konformitätserklärungen und Compliance-Dokumenten.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Logistik:</strong> Sendungsverfolgung über mehrere Spediteure, sofortige Bereitstellung von Lieferscheinen und Berechnung von Transitzeiten basierend auf aktuellen Bedingungen.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Der Multiplikatoreffekt</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Wenn Sie 80 % der Routineanfragen automatisieren:
              </p>

              <div className="overflow-x-auto mb-8">
                <table className="min-w-full border border-[#2d2f36]">
                  <thead>
                    <tr className="bg-[#0e0f13]">
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-b border-[#2d2f36] font-geist">Kennzahl</th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-[#2d2f36] font-geist">Veränderung</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#2d2f36] bg-[#010003]">
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Antwortzeit</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Von Stunden auf Sekunden reduziert</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Supportkosten</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">60-70 % Reduktion</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Kundenzufriedenheit</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">40 % Verbesserung der CSAT-Werte</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Verkaufseffekt</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Mehr Zeit für Cross-Selling und Kundenbeziehungen</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Ein Logistikunternehmen verwandelte seinen Support von einer Kostenstelle in eine Umsatzquelle, indem das Team während der Kundeninteraktionen gezielt auf Erweiterungsmöglichkeiten hinweisen konnte. Das Verständnis des Unterschieds zwischen KI-Agenten und KI-Workflows hilft Ihnen, den richtigen Ansatz für Ihre Support-Automatisierung zu wählen.
              </p>

              <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mt-12 mb-6">Anwendungsfall 4: Dokumente verifizieren und validieren (denn Vertrauen ist gut, Kontrolle ist besser)</h2>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Der Dokumentenprüfungsalbtraum</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Im Großhandel, in der Fertigung und Logistik sind Dokumente nicht nur Papierkram, sondern gesetzliche Anforderungen, Qualitätsgarantien und Prüfspuren. Jeden Tag validieren Sie:
              </p>

              <ul className="list-disc pl-6 mb-6 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed space-y-2">
                <li>Ursprungszeugnisse</li>
                <li>Qualitätszertifikate</li>
                <li>Compliance-Dokumente</li>
                <li>Frachtbriefe</li>
                <li>Liefernachweise</li>
                <li>Versicherungsbescheinigungen</li>
                <li>Sicherheitsdatenblätter</li>
              </ul>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Manuelle Überprüfung bedeutet, dass jemand PDFs durchforstet, Daten überprüft, Unterschriften validiert und hofft, nichts zu übersehen, was zu einer Zollstrafe von 50.000 € führen könnte.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">KI-gestützte Dokumentenintelligenz</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Dokumentenverifizierung mit KI bedeutet nicht nur Häkchen zu setzen, sondern sie versteht Kontext und Anforderungen:
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Intelligente Extraktion:</strong> Zieht Schlüsseldaten aus jedem Dokumententyp ohne Vorlagen. Wissen Sie sofort, ob das Zertifikat nächste Woche oder erst nächstes Jahr abläuft.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Compliance-Prüfung:</strong> Automatische Validierung gemäß regulatorischer Anforderungen. Fehlende Dokumente werden markiert, bevor es zu Lieferverzögerungen kommt. Bleiben Sie bei den sich ständig ändernden KI-Sicherheits- und Compliance-Anforderungen in Europa auf dem Laufenden.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Betrugserkennung:</strong> Erkennt verdächtige Muster, veränderte Dokumente oder Unstimmigkeiten, die Menschen übersehen könnten.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Automatische Ablage:</strong> Speichert Dokumente mit intelligenter Kategorisierung und sofortigem Abruf. Verlieren Sie nie wieder ein Konformitätszertifikat im digitalen Ablagechaos. Erstellen Sie eine durchsuchbare Wissensdatenbank, mit der Sie chatten können, für sofortigen Dokumentenzugriff.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Warum Ihre Branche darauf nicht verzichten kann</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Großhandel:</strong> Überprüfung von Lieferantenzertifikaten, Validierung der Produktauthentizität und Sicherstellung der Compliance bei Tausenden von Artikeln. Ein Großhändler vermied Strafen in Höhe von 2 Mio. €, indem er abgelaufene Zertifikate entdeckte, bevor es der Zoll tat.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Fertigung:</strong> Verfolgung von Materialzertifikaten in der gesamten Lieferkette. Sicherstellung, dass jede Komponente vor der Produktion den Spezifikationen entspricht.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Logistik:</strong> Validierung von Zolldokumenten gemäß den Anforderungen von über 50 Ländern. Überprüfung der Versicherungsdeckung, Spediteurszertifikate und Gefahrgutdokumentation.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die Rendite durch Risikominimierung</h3>

              <div className="overflow-x-auto mb-8">
                <table className="min-w-full border border-[#2d2f36]">
                  <thead>
                    <tr className="bg-[#0e0f13]">
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-b border-[#2d2f36] font-geist">Kennzahl</th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-[#2d2f36] font-geist">Ergebnis</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#2d2f36] bg-[#010003]">
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Vermeidung von Compliance-Verstößen</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">10.000-1.000.000 € pro Vorfall</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Bearbeitungszeit</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">90 % Reduktion</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Prüfungsvorbereitung</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Von Wochen auf Stunden reduziert</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Dokumentenabruf</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Von 30 Minuten auf 3 Sekunden reduziert</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Ein Hersteller entdeckte, dass 15 % der Lieferantenzertifikate abgelaufen oder ungültig waren bevor es die Aufsichtsbehörden taten. Das ist der Unterschied zwischen einer Prozessverbesserung und einer existenzbedrohenden Geldstrafe.
              </p>










              <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mt-12 mb-6">Anwendungsfall 5: Produktion planen, als könnten Sie die Zukunft sehen (Spoiler: Können Sie fast)</h2>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Das Produktionsplanungs-Chaos</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Jeder Hersteller kennt diese Herausforderungen: Sie jonglieren mit Kundenaufträgen, Materialverfügbarkeit, Maschinenkapazität, Arbeitskräfteplanung und Wartungsfenstern und das alles während Sie versuchen, Termintreue, Kosten und Qualität zu optimieren.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Die meisten Unternehmen „planen“ ihre Produktion mit:
              </p>

              <ul className="list-disc pl-6 mb-6 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed space-y-2">
                <li>Excel-Tabellen, die abstürzen, wenn man sie schief anschaut</li>
                <li>Whiteboards, die seit Dienstag nicht mehr aktualisiert wurden</li>
                <li>Dem Bauchgefühl von Thomas (der geht nächsten Monat in Rente)</li>
                <li>Gebeten zum Himmel</li>
              </ul>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Das Ergebnis? 20 % verschwendete Produktionskapazität, Expresskosten, die Ihren CFO zum Weinen bringen, und Kundentermine, die eher „Vorschläge“ als „Verpflichtungen“ sind.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">KI-gestützte Produktionsintelligenz</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Moderne KI-gestützte Datenanalysen planen nicht nur, sondern sie optimieren gleichzeitig über mehrere Dimensionen hinweg:
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Nachfrageprognose:</strong> Analysiert historische Muster, saisonale Trends und Marktsignale, um die Nachfrage vorherzusagen, bevor Aufträge eintreffen.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Kapazitätsoptimierung:</strong> Balanciert Maschinenlaufzeiten, Personalverfügbarkeit und Materialfluss, um den Durchsatz zu maximieren, ohne Anlagen oder Mitarbeiter zu überlasten.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Szenarioplanung:</strong> Führt sofort „Was-wäre-wenn“-Analysen durch. Was, wenn der Großauftrag kommt? Was, wenn Maschine 3 gewartet werden muss? Was, wenn die Rohstoffpreise explodieren?
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Echtzeit-Anpassung:</strong> Plant automatisch um, wenn Störungen auftreten. Maschinenausfall? Dringender Zusatzauftrag? Die KI passt den gesamten Produktionsplan in Sekunden an, nicht in Stunden. Erfahren Sie, wie Sie komplexe Workflows wie die Produktionsplanung mit KI automatisieren können.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die dreifache Branchenwirkung</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Großhandel + Fertigung:</strong> Koordination von Produktion mit Lagerbeständen und eingehenden Aufträgen. Wissen Sie genau, wann Sie produzieren und wann Sie aus dem Lager liefern sollten.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Fertigung + Logistik:</strong> Synchronisierung von Produktionsabschluss mit Versandplänen. Keine fertigen Waren mehr, die im Lager auf Abholung warten.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Das perfekte Trio:</strong> Wenn alle drei Branchen KI-gestützte Planung nutzen, geschieht Magie. Aufträge fließen nahtlos vom Kunden über die Produktion bis zur Auslieferung ohne menschliches Zutun.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die Kapazitätsgewinne, die alles verändern</h3>

              <div className="overflow-x-auto mb-8">
                <table className="min-w-full border border-[#2d2f36]">
                  <thead>
                    <tr className="bg-[#0e0f13]">
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-b border-[#2d2f36] font-geist">Kennzahl</th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-[#2d2f36] font-geist">Verbesserung</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#2d2f36] bg-[#010003]">
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Kapazitätsauslastung</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Von 65 % auf über 85 %</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Termintreue</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Von 70 % auf 95 %</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Expresskosten</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">80 % Reduktion</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Planungszeit</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Von Tagen auf Minuten reduziert</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Ein Hersteller steigerte seine Produktion um 30 %, indem er lediglich die Produktionsabläufe und Rüstzeiten optimierte. Das ist, als würde man eine kostenlose Fabrik in der bestehenden Fabrik entdecken.
              </p>








              <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mt-16 mb-6">Anwendungsfall 6: Erstellen Sie Angebote, die tatsächlich zum Abschluss führen (Kein Angebots-Roulette mehr)</h2>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Das Angebotschaos</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Angebotserstellung ist der Punkt, an dem Geschäfte oft scheitern. Ihr Vertriebsteam verbringt Stunden oder Tage damit:
              </p>

              <ul className="list-disc pl-6 mb-6 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed space-y-2">
                <li>Verfügbarkeit von Produkten in verschiedenen Systemen zu prüfen</li>
                <li>Preise mit komplexen Rabatten und Staffelungen zu berechnen</li>
                <li>Liefertermine zu schätzen, indem sie das Lager anrufen</li>
                <li>Frachtkosten mit veralteten Tarifkarten zu berechnen</li>
                <li>Alles in Word zu formatieren (dann als PDF, dann zurück zu Word, weil sich etwas geändert hat)</li>
              </ul>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Bis das Angebot beim Kunden ankommt, hat Ihr Wettbewerber das Geschäft bereits mit seiner sofortigen Antwort gewonnen.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">KI-gestützte Angebotserstellung</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Moderne KI-Angebotserstellung verwandelt das Erstellen von Angeboten von einer Kunst in eine Wissenschaft. Im Gegensatz zu herkömmlichen Automatisierungstools versteht KI den Kontext und kann komplexe Konfigurationen bewältigen:
              </p>

              <ul className="list-disc pl-6 mb-6 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed space-y-2">
                <li><strong>Sofortige Konfiguration:</strong> KI versteht Produktkombinationen, Kompatibilitätsanforderungen und Kundenpräferenzen. Sie weiß, dass Bauteil A Adapter B erfordert, wenn es mit System C verwendet wird.</li>
                <li><strong>Dynamische Preisgestaltung:</strong> Berechnen Sie Preise basierend auf aktuellen Kosten, Lagerbeständen, Kundenhistorie und Wettbewerbsdaten. Maximieren Sie die Marge, während Sie Geschäfte gewinnen.</li>
                <li><strong>Präzise Lieferzusagen:</strong> Berücksichtigen Sie aktuelle Produktionskapazitäten, Lagerbestände und logistische Einschränkungen. Versprechen Sie Termine, die Sie auch einhalten können.</li>
                <li><strong>Intelligente Alternativen:</strong> Schlagen Sie Ersatzprodukte vor, wenn Artikel nicht verfügbar sind. Bieten Sie auf Basis von Kaufmustern ergänzende Artikel an.</li>
              </ul>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Warum Geschwindigkeit (Ihren Wettbewerb) tötet</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Großhandelstempo:</strong> Bieten Sie Tausende von Positionen in Sekunden an. Ein Großhändler reduzierte die Angebotszeit von 4 Stunden auf 4 Minuten und steigerte gleichzeitig die Erfolgsquote um 35 %. Sie nutzten VIBE-Automatisierung, um den gesamten Workflow nur durch Beschreibung zu erstellen.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Fertigungspräzision:</strong> Erstellen Sie komplexe, kundenkonfigurierte Angebote mit genauen Lieferzeiten. Inklusive technischer Spezifikationen, Compliance-Informationen und kundenspezifischer Anforderungen.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                <strong>Logistikgenauigkeit:</strong> Kalkulieren Sie multimodale Sendungen mit Echtzeit-Speditionspreisen, Transitzeiten und allen Zusatzkosten. Keine bösen Überraschungen mehr, die Ihre Marge auffressen.
              </p>

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Die Auswirkungen auf den Umsatz</h3>

              <div className="overflow-x-auto mb-8">
                <table className="min-w-full border border-[#2d2f36]">
                  <thead>
                    <tr className="bg-[#0e0f13]">
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-b border-[#2d2f36] font-geist">Kennzahl</th>
                      <th className="px-6 py-3 text-left text-sm font-medium text-[#a1a1aa] border-[#2d2f36] font-geist">Verbesserung</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-[#2d2f36] bg-[#010003]">
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Angebotserstellung</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Von Tagen auf Minuten reduziert</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Erfolgsquote</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">25-40 % Steigerung</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Angebotsgenauigkeit</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">Über 99 % (keine margenschädigenden Fehler mehr)</td>
                    </tr>
                    <tr>
                      <td className="px-6 py-4 text-sm text-white border-r border-[#2d2f36] font-geist">Vertriebsproduktivität</td>
                      <td className="px-6 py-4 text-sm text-white font-geist">3x mehr Angebote pro Vertriebsmitarbeiter</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Die Erfolgsgeschichte von Ynvolve zeigt, wie sie die Angebotserstellung um 90 % beschleunigten und ein Umsatzwachstum von 50 % ohne zusätzliche Vertriebsmitarbeiter prognostizieren. Das ist die Macht, den langsamsten Prozess in Ihren größten Wettbewerbsvorteil zu verwandeln.
              </p>








              <div className="space-y-16 mt-16">
                <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mb-8">Der branchenspezifische Implementierungsleitfaden</h2>
                
                <div className="space-y-12">
                  <div>
                    <h3 className="text-xl font-geist font-normal text-white/90 mb-6 pb-2 border-b border-white/10">Für Großhändler</h3>
                    <div className="space-y-6">
                      <div>
                        <h4 className="text-white/90 font-normal mb-2">Woche 1-2: Auftragserstellung</h4>
                        <ul className="space-y-1 text-white/70 text-base font-geist font-light pl-4">
                          <li className="list-disc">Automatisieren Sie zuerst Ihren umsatzstärksten Kunden</li>
                          <li className="list-disc">Verbinden Sie sich mit Ihren ERP- und Bestandssystemen</li>
                          <li className="list-disc">Führen Sie parallel durch, um Sicherheit zu gewinnen</li>
                        </ul>
                      </div>
                      <div>
                        <h4 className="text-white/90 font-normal mb-2">Woche 3-4: Rechnungsverarbeitung</h4>
                        <ul className="space-y-1 text-white/70 text-base font-geist font-light pl-4">
                          <li className="list-disc">Konzentrieren Sie sich auf Ihre größten Lieferanten</li>
                          <li className="list-disc">Nutzen Sie sofortige Skontomöglichkeiten</li>
                          <li className="list-disc">Beobachten Sie die Verbesserung Ihrer Liquidität</li>
                        </ul>
                      </div>
                      <div className="bg-[#0e0f13] p-4 rounded-lg">
                        <p className="text-white/80 text-sm">
                          <strong className="text-white/90">Der Großhandels-Multiplikator:</strong> Wenn Aufträge, Rechnungen und Support automatisiert sind, können Sie das Fünffache des Volumens mit demselben Personal bewältigen. Das ist Skalierung ohne zusätzliche Kosten.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-xl font-geist font-normal text-white/90 mb-6 pb-2 border-b border-white/10">Für Hersteller</h3>
                    <div className="space-y-6">
                      <div>
                        <h4 className="text-white/90 font-normal mb-2">Woche 1-2: Dokumentenverifizierung</h4>
                        <ul className="space-y-1 text-white/70 text-base font-geist font-light pl-4">
                          <li className="list-disc">Starten Sie mit Lieferantenzertifikaten</li>
                          <li className="list-disc">Vermeiden Sie Compliance-Verstöße</li>
                          <li className="list-disc">Bauen Sie Ihr digitales Dokumentenarchiv auf</li>
                        </ul>
                      </div>
                      <div>
                        <h4 className="text-white/90 font-normal mb-2">Woche 3-4: Produktionsplanung</h4>
                        <ul className="space-y-1 text-white/70 text-base font-geist font-light pl-4">
                          <li className="list-disc">Beginnen Sie mit einer Produktionslinie</li>
                          <li className="list-disc">Beweisen Sie den ROI durch bessere Auslastung</li>
                          <li className="list-disc">Erweitern Sie die Optimierung</li>
                        </ul>
                      </div>
                      <div className="bg-[#0e0f13] p-4 rounded-lg">
                        <p className="text-white/80 text-sm">
                          <strong className="text-white/90">Der Herstellervorteil:</strong> Die Verbindung von Planung, Angebotserstellung und Dokumenten schafft eine sich selbst optimierende Fabrik, die in Echtzeit auf Marktanforderungen reagiert.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-xl font-geist font-normal text-white/90 mb-6 pb-2 border-b border-white/10">Für Logistikdienstleister</h3>
                    <div className="space-y-6">
                      <div>
                        <h4 className="text-white/90 font-normal mb-2">Woche 1-2: Supportanfragen</h4>
                        <ul className="space-y-1 text-white/70 text-base font-geist font-light pl-4">
                          <li className="list-disc">Beginnen Sie mit Sendungsverfolgung</li>
                          <li className="list-disc">Reduzieren Sie Routineanfragen um 80%</li>
                          <li className="list-disc">Verbessern Sie die Kundenzufriedenheit</li>
                        </ul>
                      </div>
                      <div>
                        <h4 className="text-white/90 font-normal mb-2">Woche 3-4: Dokumentenverifizierung</h4>
                        <ul className="space-y-1 text-white/70 text-base font-geist font-light pl-4">
                          <li className="list-disc">Fokus auf Zolldokumente</li>
                          <li className="list-disc">Reduzieren Sie Grenzverzögerungen</li>
                          <li className="list-disc">Beschleunigen Sie die Abwicklung</li>
                        </ul>
                      </div>
                      <div className="bg-[#0e0f13] p-4 rounded-lg">
                        <p className="text-white/80 text-sm">
                          <strong className="text-white/90">Der Logistik-Vorteil:</strong> Wenn Dokumente automatisch fließen und der Support sofort verfügbar ist, werden Sie zum Transportunternehmen, mit dem jeder zusammenarbeiten möchte.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>










              

            

              <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-12 mb-4">Das Muster ist klar</h3>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Unternehmen, die diese sechs Anwendungsfälle automatisieren, verzeichnen:
              </p>

              <div className="mb-8 grid md:grid-cols-2 gap-6">
                <div className="p-6 bg-[#0e0f13] rounded-lg">
                  <h4 className="text-white text-lg font-geist font-normal tracking-[-0.02em] mb-4">Operative Kostensenkung</h4>
                  <p className="text-3xl font-bold text-white">30-50%</p>
                  <p className="text-sm text-white/30 mt-2">Reduktion der Betriebskosten</p>
                </div>
                <div className="p-6 bg-[#0e0f13] rounded-lg">
                  <h4 className="text-white text-lg font-geist font-normal tracking-[-0.02em] mb-4">Schnellere Bearbeitung</h4>
                  <p className="text-3xl font-bold text-white">60-80%</p>
                  <p className="text-sm text-white/30 mt-2">Schnellere Bearbeitungszeiten</p>
                </div>
                <div className="p-6 bg-[#0e0f13] rounded-lg">
                  <h4 className="text-white text-lg font-geist font-normal tracking-[-0.02em] mb-4">Weniger Fehler</h4>
                  <p className="text-3xl font-bold text-white">90%+</p>
                  <p className="text-sm text-white/30 mt-2">Reduktion von Fehlern</p>
                </div>
                <div className="p-6 bg-[#0e0f13] rounded-lg">
                  <h4 className="text-white text-lg font-geist font-normal tracking-[-0.02em] mb-4">Rendite</h4>
                  <p className="text-3xl font-bold text-white">200-400%</p>
                  <p className="text-sm text-white/30 mt-2">ROI innerhalb von 12 Monaten</p>
                </div>
              </div>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6 text-left">
                Erfahren Sie mehr über die Messung des ROI von KI-Automatisierung in Ihrem Unternehmen.
              </p>








              <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mt-16 mb-8">Ihr 30 Tage Transformationsplan</h2>

              <div className="space-y-12 mb-16">
                <div>
                  <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mb-3">Tag 1-5: Analyse & Strategie</h3>
                  <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed">
                    Unser Expertenteam begleitet Sie von Anfang an. In intensiven Workshops analysieren wir gemeinsam Ihre individuellen Anforderungen und Geschäftsprozesse, um den optimalen Einstiegspunkt für Ihre Automatisierungsreise zu identifizieren.
                  </p>
                </div>

                <div>
                  <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mb-3">Tag 6-10: Bestandsaufnahme & Analyse</h3>
                  <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-3">
                    Unser Beratungsteam führt eine detaillierte Analyse Ihrer aktuellen Prozesslandschaft durch:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed">
                    <li>Umfassende Prozessanalyse und -dokumentation</li>
                    <li>Identifikation von Effizienzpotentialen und Optimierungsmöglichkeiten</li>
                    <li>Bewertung Ihrer bestehenden IT-Infrastruktur</li>
                    <li>Erfassung relevanter Kennzahlen für die Erfolgsmessung</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mb-3">Tag 11-15: Individuelle Lösungsentwicklung</h3>
                  <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-3">
                    Basierend auf unserer Analyse entwickeln wir eine maßgeschneiderte Automatisierungslösung, die genau auf Ihre Anforderungen zugeschnitten ist. Unsere Experten beraten Sie umfassend zu den besten Ansätzen und Technologien für Ihr Unternehmen.
                  </p>
                  <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-2">
                    Unser Beratungsansatz umfasst:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed">
                    <li>Individuelle Beratung zur Prozessautomatisierung</li>
                    <li>Maßgeschneiderte Lösungsarchitektur</li>
                    <li>Branchenspezifische Best Practices</li>
                    <li>Skalierbare Konzepte für zukünftige Anforderungen</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mb-3">Tag 16-20: Implementierung & Test</h3>
                  <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-2">
                    Unser Expertenteam implementiert die Lösung in enger Abstimmung mit Ihren Mitarbeitern:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed">
                    <li>Fachgerechte Integration in Ihre bestehenden Systeme</li>
                    <li>Schrittweise Einführung mit umfassendem Testkonzept</li>
                    <li>Paralleler Betrieb zur Sicherstellung der Prozesssicherheit</li>
                    <li>Anpassungen basierend auf kontinuierlichem Feedback</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mb-3">Tag 21-25: Optimierung & Schulung</h3>
                  <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-2">
                    Unser Fokus liegt auf der nachhaltigen Etablierung der Lösung in Ihrem Unternehmen:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed">
                    <li>Systematische Steigerung des Automatisierungsgrades</li>
                    <li>Umsetzung erweiterter Anforderungen</li>
                    <li>Anpassung an spezifische Geschäftsanforderungen</li>
                    <li>Umfassende Mitarbeiterschulungen und Wissensvermittlung</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mb-3">Tag 26-30: Auswertung & Ausblick</h3>
                  <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-2">
                    Gemeinsam mit Ihnen evaluieren wir die Ergebnisse und planen die nächsten Schritte:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed">
                    <li>Dokumentation der erreichten Ziele und Kennzahlen</li>
                    <li>Berechnung der erzielten Effizienzsteigerungen und Kosteneinsparungen</li>
                    <li>Strategische Planung weiterer Automatisierungsvorhaben</li>
                    <li>Vereinbarung von Wartungs- und Betreuungsleistungen</li>
                  </ul>
                </div>
              </div>







              <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mt-16 mb-6">Häufig gestellte Fragen</h2>

              <div className="mb-8">
                <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Unsere Branche ist anders. Wird das wirklich für uns funktionieren?</h3>
                <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                  Jedes Unternehmen hält sich für einzigartig. Sind Sie nicht. Sie bearbeiten Bestellungen, verarbeiten Rechnungen, beantworten Fragen, prüfen Dokumente, planen die Produktion und erstellen Angebote. Die Details variieren, aber die Prozesse sind universell.
                </p>
              </div>

              <div className="mb-8">
                <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Wie lange dauert es, bis wir einen ROI sehen?</h3>
                <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                  Die meisten Unternehmen sehen innerhalb von 3-6 Monaten einen positiven ROI. Hochvolumige Prozesse wie Bestelleingang oder Rechnungsverarbeitung amortisieren sich oft innerhalb von Wochen.
                </p>
              </div>

              <div className="mb-8">
                <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Was ist, wenn unsere Systeme nicht integriert werden können?</h3>
                <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                  Moderne Plattformen bieten über 2.000 vorgefertigte Integrationen. Wenn Ihr ERP-System aus dem Jahr 1987 nicht auf der Liste steht, können wir in der Regel über CSV, Datenbank oder API eine Verbindung herstellen. Wir sind noch auf kein System gestoßen, das wir nicht integrieren konnten.
                </p>
              </div>

              <div className="mb-8">
                <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Müssen wir unsere bestehenden Systeme ersetzen?</h3>
                <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                  Nein! KI-Automatisierung setzt auf Ihren bestehenden Systemen auf und verbindet sie intelligent. Behalten Sie Ihr ERP-, WMS- und TMS-System. Lassen Sie sie einfach nahtlos zusammenarbeiten.
                </p>
              </div>

              <div className="mb-8">
                <h3 className="text-white text-xl font-geist font-normal tracking-[-0.02em] mt-8 mb-4">Was ist mit unseren komplexen Preisen/Produkten/Prozessen?</h3>
                <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                  Komplexität ist genau das, worin KI glänzt. Regelbasierte Systeme scheitern an Komplexität. KI gedeiht daran. Je komplexer Ihre Abläufe sind, desto größer ist Ihr Vorteil durch Automatisierung. Testen und validieren Sie Ihre spezifischen Szenarien vor der vollständigen Bereitstellung.
                </p>
              </div>

              <h2 className="text-white text-2xl font-geist font-normal tracking-[-0.02em] mt-16 mb-6">Das Fazit: Automatisieren oder verschwinden</h2>
              
              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Unternehmen im Großhandel, in der Fertigung und Logistik, die die Automatisierung des Backoffices ignorieren, lassen nicht nur Geld auf dem Tisch liegen, sie unterschreiben ihr eigenes Todesurteil. Während Sie noch Bestellungen manuell eingeben, versendet Ihr Konkurrent bereits. Während Sie Rechnungen bearbeiten, nutzt er Skontomöglichkeiten. Während Sie Angebote erstellen, hat er das Geschäft bereits gewonnen.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Die sechs hier beschriebenen Anwendungsfälle sind keine netten Zusatzfunktionen. Sie sind der Unterschied zwischen Erfolg und Scheitern in Branchen, in denen die Margen gering und der Wettbewerb hart ist.
              </p>

              <p className="text-white/70 text-base font-geist font-light tracking-[-0.02em] leading-relaxed mb-6">
                Die Technologie ist da. Die Rentabilität ist bewiesen. Die einzige Frage ist, ob Sie diese Transformation anführen werden oder zusehen, wie Ihre Konkurrenten Ihnen davonziehen.
              </p>

              <div className="border-t border-white/10 my-12 pt-12">
                <h3 className="text-xl font-geist font-medium tracking-[-0.02em] mb-6"><span className="text-white">Bereit zu starten?</span> <span className="text-white/50">Analysiere dein Unternehmen mit unserer kostenlosen <br/>KI-Potentialanalyse oder kontaktiere uns direkt!</span></h3>
                <div className="flex flex-wrap gap-4">
                  <a href="https://audit.blcks.at" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-2.5 bg-white text-gray-900 font-geist font-medium text-sm rounded-full hover:bg-gray-100 transition-colors">
                    Kostenlose KI-Analyse starten
                  </a>
                  <a href="/contact" className="inline-flex items-center justify-center px-6 py-2.5 border border-white/20 text-white font-geist font-medium text-sm rounded-full hover:bg-white/5 transition-colors">
                    Jetzt beraten lassen
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </article>
      
      <FooterWrapper />
    </div>
  );
};

export default BackofficeAutomations;
